export default "__VITE_ASSET__JBM7znB8__"